import { queryKeys } from '@/lib/query-keys';
import { notificationSettingsClient } from '@/lib/api/ts-rest';
import { useQuery } from '@tanstack/react-query';


export function useNotificationSettings(organizationId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.notifications.settings(organizationId),
    queryFn: async () => {
      const res = await notificationSettingsClient.getNotificationSettings({
        params: { organizationId: organizationId! },
      });
      if (res.status !== 200) throw new Error('Failed to load settings');
      return res.body;
    },
    enabled: !!organizationId,
  });
}
